import api from '../index';
import {PaginationParams} from '../pagination';
import {
  GigsFilters,
  PaidGigsOptions,
  AvailableGigsResponse,
  InvitedGigsResponse,
  PaidGigsResponse,
} from './types';
import {
  DEFAULT_PAGINATION_PAGE_SIZE,
  API_FILTERS,
  API_PARAM_SETS,
} from './constants';

const gigsApi = {
  // Todo: Get a single gig by ID - will be added in the future

  // Get list of available gigs with pagination support
  availableGigsList: async (
    filters: GigsFilters = {},
    pagination?: PaginationParams,
    customIncludes?: string[]
  ): Promise<AvailableGigsResponse> => {
    const response = await api.get('/user/campaign_list_items', {
      params: {
        include: customIncludes || API_PARAM_SETS.STANDARD_INCLUDES,
        filter: API_FILTERS.WITHOUT_INVITES,
        page: pagination?.page || 1,
        per_page: pagination?.per_page || DEFAULT_PAGINATION_PAGE_SIZE,
        ...filters,
      },
    });

    return {
      data: response.data,
      pagination: response.meta.pagination,
    };
  },

  // Get count of available gigs with filtering options
  filteredGigsCount: (filters: GigsFilters = {}) =>
    api.get('/user/campaign_list_items/count', {
      params: {
        filter: API_FILTERS.WITHOUT_INVITES,
        ...filters,
      },
    }),

  // Get list of invited gigs with pagination
  invitedGigsList: async (
    pagination?: PaginationParams,
    customIncludes?: string[]
  ): Promise<InvitedGigsResponse> => {
    const response = await api.get('/user/campaign_creator_matches', {
      params: {
        include: customIncludes || API_PARAM_SETS.INVITED_GIGS_INCLUDES,
        filter: API_FILTERS.INVITED,
        page: pagination?.page || 1,
        per_page: pagination?.per_page || DEFAULT_PAGINATION_PAGE_SIZE,
      },
    });

    return {
      data: response.data,
      pagination: response.meta.pagination,
    };
  },

  // Get list of paid gigs with pagination and scope support
  paidGigsList: async (
    options: PaidGigsOptions = {},
    pagination?: PaginationParams,
    customIncludes?: string[]
  ): Promise<PaidGigsResponse> => {
    const response = await api.get('/user/paid_gigs', {
      params: {
        include: customIncludes || API_PARAM_SETS.PAID_GIGS_INCLUDES,
        page: pagination?.page || 1,
        per_page: pagination?.per_page || DEFAULT_PAGINATION_PAGE_SIZE,
        scope: options.scope,
      },
    });

    return {
      data: response.data,
      pagination: response.meta.pagination,
    };
  },
};

export default gigsApi;
